import React from 'react';
import { observer } from 'mobx-react-lite';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import {
    SourceOfFundsActionBlock,
    SourceOfFundsActionLabel,
    SourceOfFundsActionOption,
    SourceOfFundsActionOptions,
} from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFunds.style';
import { SourceOfFundsActionSelectionType } from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFunds.types';
import { SourceOfFundsRestrictionPeriodDropdown } from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFundsRestrictionPeriodDropdown';

interface SourceOfFundsActionPickerPropsType {
    dataTestPrefix: string;
    selection: SourceOfFundsActionSelectionType;
    onSetAction: (key: keyof SourceOfFundsActionSelectionType, value: boolean) => void;
    onClearAll: () => void;
    complianceRestrictionPeriod: string;
    onChangeComplianceRestrictionPeriod: (value: string) => void;
}

export const SourceOfFundsActionPicker = observer(
    ({
        dataTestPrefix,
        selection,
        onSetAction,
        onClearAll,
        complianceRestrictionPeriod,
        onChangeComplianceRestrictionPeriod,
    }: SourceOfFundsActionPickerPropsType): JSX.Element => {
        const isNoneSelected = !selection.complianceRestriction && !selection.sendEmail && !selection.showPopup;

        return (
            <SourceOfFundsActionOptions data-test={`${dataTestPrefix}-action-picker`}>
                <SourceOfFundsActionBlock>
                    <SourceOfFundsActionOption as='div'>
                        <Checkbox
                            dataTest={`${dataTestPrefix}-action-compliance-restriction`}
                            isBackground
                            isChecked={selection.complianceRestriction}
                            isDisabled={false}
                            labelSide='right'
                            onChange={(): void => {
                                onSetAction('complianceRestriction', !selection.complianceRestriction);
                            }}
                        >
                            <SourceOfFundsActionLabel>Apply Compliance Restriction</SourceOfFundsActionLabel>
                        </Checkbox>
                    </SourceOfFundsActionOption>
                    {selection.complianceRestriction ? (
                        <SourceOfFundsRestrictionPeriodDropdown
                            dataTestPrefix={dataTestPrefix}
                            onChange={onChangeComplianceRestrictionPeriod}
                            value={complianceRestrictionPeriod}
                        />
                    ) : null}
                </SourceOfFundsActionBlock>

                <SourceOfFundsActionOption as='div'>
                    <Checkbox
                        dataTest={`${dataTestPrefix}-action-send-email`}
                        isBackground
                        isChecked={selection.sendEmail}
                        isDisabled={false}
                        labelSide='right'
                        onChange={(): void => {
                            onSetAction('sendEmail', !selection.sendEmail);
                        }}
                    >
                        <SourceOfFundsActionLabel>Send an Email</SourceOfFundsActionLabel>
                    </Checkbox>
                </SourceOfFundsActionOption>

                <SourceOfFundsActionOption as='div'>
                    <Checkbox
                        dataTest={`${dataTestPrefix}-action-show-popup`}
                        isBackground
                        isChecked={selection.showPopup}
                        isDisabled={false}
                        labelSide='right'
                        onChange={(): void => {
                            onSetAction('showPopup', !selection.showPopup);
                        }}
                    >
                        <SourceOfFundsActionLabel>Display a Pop-Up</SourceOfFundsActionLabel>
                    </Checkbox>
                </SourceOfFundsActionOption>

                <SourceOfFundsActionOption as='div'>
                    <Checkbox
                        dataTest={`${dataTestPrefix}-action-none`}
                        isBackground
                        isChecked={isNoneSelected}
                        isDisabled={false}
                        labelSide='right'
                        onChange={(): void => {
                            if (!isNoneSelected) {
                                onClearAll();
                            }
                        }}
                    >
                        <SourceOfFundsActionLabel>None</SourceOfFundsActionLabel>
                    </Checkbox>
                </SourceOfFundsActionOption>
            </SourceOfFundsActionOptions>
        );
    }
);
